import EventBus from '../event-bus';

export async function showToast(response, message) {
    EventBus.emit('show-toast', { severity: response?.severity ?? 'error', summary: response?.summary ?? 'Error', detail: message, life: 5000 });
}
